import { render, staticRenderFns } from "./BillPackStockRecord.vue?vue&type=template&id=25d5a696&scoped=true&"
import script from "./BillPackStockRecord.vue?vue&type=script&lang=js&"
export * from "./BillPackStockRecord.vue?vue&type=script&lang=js&"
import style0 from "./BillPackStockRecord.vue?vue&type=style&index=0&id=25d5a696&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5a696",
  null
  
)

export default component.exports